export const REACT_APP_CAT_API_URL = "https://node-app-lmhzwhyv4q-as.a.run.app";
export const REACT_APP_SITE_KEY = "6LfxyJcjAAAAAF_9qZWhb1U2XRL8Ctp8gHDKs-4G";
export const REACT_APP_MAPTILER_API_KEY = "hidden";
export const REACT_APP_MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1Ijoia25vd3lvdXJlbmVteSIsImEiOiJjbGQ4dGNncXowMmV5M3dwNHVxeDl5N2ZzIn0.DRmFDGEKnFCWsIeD1YS0fA";
